import React from 'react'

import PropTypes from 'prop-types'

import {
  ConfirmDialog,
  ConfirmDialogActions,
  ConfirmDialogContent,
  ConfirmDialogTitle,
} from '../../styles/components/ConfirmDialogStyle'

const AlertDialog = ({ isDialogOpen, handleDialog, title, description, children }) => {
  return (
    <ConfirmDialog
      open={isDialogOpen}
      onClose={handleDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ConfirmDialogTitle>{title}</ConfirmDialogTitle>
      {description && <ConfirmDialogContent>{description}</ConfirmDialogContent>}
      <ConfirmDialogActions>{children}</ConfirmDialogActions>
    </ConfirmDialog>
  )
}

AlertDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  handleDialog: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired, // dialog's buttons
}

export default AlertDialog
